export default __webpack_public_path__ + "static/media/3.2efb1f62.mp4";